/* Helpers de formatacao para datas, CPF, etc. */

const WEEKDAYS = ["Domingo", "Segunda", "Terca", "Quarta", "Quinta", "Sexta", "Sabado"];
const MONTHS = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez",
];

export function formatCPF(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 11);
  return digits
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function onlyDigits(s) {
  return (s || "").replace(/\D/g, "");
}

function normalizeDateInput(str) {
  if (!str) return "";

  const s = String(str).trim();

  // dd-mm-yyyy HH:mm:ss ou dd/mm/yyyy HH:mm:ss
  const br = s.match(/^(\d{2})[-/](\d{2})[-/](\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (br) {
    const [, dd, mm, yyyy, hh = "00", mi = "00", ss = "00"] = br;
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
  }

  // yyyy-mm-dd HH:mm:ss
  const isoLike = s.match(/^(\d{4})-(\d{2})-(\d{2})[ ](\d{2}):(\d{2})(?::(\d{2}))?/);
  if (isoLike) {
    return s.replace(" ", "T");
  }

  return s;
}

export function parseISO(str) {
  if (!str) return null;
  const d = new Date(normalizeDateInput(str));
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function formatLongDate(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  const wd = WEEKDAYS[d.getDay()];
  const dd = String(d.getDate()).padStart(2, "0");
  const mo = MONTHS[d.getMonth()];
  return `${wd}, ${dd} de ${mo}`;
}

export function formatDate(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]}`;
}

export function formatTime(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function formatDateTime(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  return `${formatLongDate(iso)} as ${formatTime(iso)}`;
}

export function dayKey(iso) {
  const d = parseISO(iso);
  if (!d) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function periodOf(iso) {
  const d = parseISO(iso);
  if (!d) return "Outros";
  const h = d.getHours();
  if (h < 12) return "Manha";
  if (h < 18) return "Tarde";
  return "Noite";
}

export function groupSlotsByDay(slots) {
  const map = new Map();

  for (const s of slots) {
    const k = dayKey(s.datetime);
    if (!map.has(k)) map.set(k, []);
    map.get(k).push(s);
  }

  return Array.from(map.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, items]) => ({
      day: k,
      label: formatLongDate(items[0].datetime),
      items: items.sort((a, b) => a.datetime.localeCompare(b.datetime)),
    }));
}